export default "__VITE_ASSET__PTcqudOt__"